<template>
    <div>
        <vx-card title="아이피 등록">
            <div class="flex justify-end flex-wrap">
                <vs-chip color="primary">
                    <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" />
                    <span>+ 아이피 등록</span>
                </vs-chip>
            </div>
        </vx-card>
    </div>
</template>

<script>
export default {};
</script>

<style></style>
